import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import mapValues from 'lodash/mapValues';
import property from 'lodash/property';
import reducePf from 'lodash/fp/reduce';
import memoize from 'lodash/memoize';
var unpackArrayIds = reducePf(function (accum, el) {
  return [].concat(_toConsumableArray(accum), [_typeof(el) === 'object' ? el.id : el]);
}, []);

var unpackStringIds = function unpackStringIds(ids) {
  return ids.split(/,\s+?/g).reduce(function (list, entry) {
    return list.concat(parseInt(entry, 10));
  }, []);
};

export var unpackIds = function unpackIds(ids) {
  return typeof ids === 'string' ? unpackStringIds(ids) : unpackArrayIds(ids);
}; // given:
//   store = { some: { nested: { attribute: 'hi' } }, cards: [1,2,3] }
//   dataSources = { componentProp: 'some.nested.attribute', offers: 'cards' }
// `createStructuredSelector` takes in an object with getters so we need to
// remap the plain paths into those getters.

export var connectToDataSources = function connectToDataSources(dataSources) {
  return connect(createStructuredSelector(mapValues(dataSources, property)));
}; // given:
//   store = {
//      some: { nested: { attribute: 'hi' } },
//      cds: {
//        allProducts: { 1: someproduct, 4: someOtherproduct },
//        receiptOrder: [1, 4],
//      },
//      loading: {
//        cds: false,
//      },
//    },
//   dataDependency = {
//     type: 'cds',
//     rawMappings: { componentProp: 'some.nested.attribute' },
//     ids: [{ id: 1 }, { id: 4}]
//   }
// `createStructuredSelector` takes in an object with getters so we need to
// remap the plain paths into those getters.

export var wrapWithConnect = function wrapWithConnect(dataDependency) {
  return connect(createStructuredSelector(_objectSpread({
    allProducts: property("".concat(dataDependency.type, ".allProducts")),
    receiptOrder: property("".concat(dataDependency.type, ".receiptOrder")),
    dataDependencyIsLoading: property("loading.".concat(dataDependency.type))
  }, mapValues(dataDependency.rawMappings, property))), null, function (stateProps, dispatchProps, ownProps) {
    return _objectSpread({}, stateProps, dispatchProps, ownProps, {
      dataDependencyType: dataDependency.type
    });
  });
}; // for components that are connected to the store, we want to memoize the connected component
// to prevent unnecessary un-mounting and re-mounting of the same component

var memoizedWrapWithConnect = memoize(function (_ref) {
  var Component = _ref.Component,
      dataDependency = _ref.dataDependency;
  return wrapWithConnect(dataDependency)(Component);
}, function (_ref2) {
  var componentType = _ref2.componentType,
      dataDependency = _ref2.dataDependency;
  return "".concat(componentType, "-").concat(dataDependency.type);
});
export var connectToDataDependency = function connectToDataDependency(dataDependency, Component, componentType) {
  return dataDependency.rawMappings ? // rawMappings can change across different instances of the same component/data dependency combo,
  // so we can't memoize; we just call wrapWithConnect directly in this case
  wrapWithConnect(dataDependency)(Component) : // memoize the connect call based on the component type + data dependency combination
  memoizedWrapWithConnect({
    dataDependency: dataDependency,
    Component: Component,
    componentType: componentType
  });
};